import styled from "styled-components";

export const ContainerHeadline = styled.div`
  h2 {
    font-size: var(--sz-title-2);
    text-align: center;
  }

  p {
    font-size: var(--sz-text-2);
    color: var(--color-gray-3);
    text-align: center;
    margin: 1.2rem 0;
  }
`;
